export class AddressAutocompleteResult {
    street_address!: string;
    postal_code!: string;
    city!: string;
    lat!: number;
    long!: number;
    display!: string;
}
